<template>
  <div>
    <div class="tp-choose" style="display:block">
      <div class="tp-choose-item tp-choose-block" :class="{'tp-choose-item-active':maker=='self'}" @click="chooseMaker('self')">
        <div class="tp-choose-icon">
          <img v-if="maker=='self'" src="../../../../assets/images/selfmake2.png">
          <img v-else src="../../../../assets/images/selfmake1.png">
        </div>
        <div class="tp-choose-text">自己制作</div>
        <div class="tp-choose-sub">自己动手，丰衣足食</div>
      </div>
      <div class="tp-choose-item tp-choose-block" :class="{'tp-choose-item-active':maker=='other'}" @click="chooseMaker('other')">
        <div class="tp-choose-icon">
          <img v-if="maker=='other'" src="../../../../assets/images/todata2.png">
          <img v-else src="../../../../assets/images/todata1.png">
        </div>
        <div class="tp-choose-text">发送行政制作</div>
        <div class="tp-choose-sub">没时间？找帮手！</div>
      </div>
    </div>
    <div v-show="maker=='other'">
      <div style="color:#999;margin:5px 0;font-size:12px">给数据同事的备注：</div>
      <el-input
        class="tp-textarea"
        resize="none"
        type="textarea"
        :rows="2"
        placeholder="嘱咐数据同事的注意事项或者备注要求，同步发给数据"
        v-model="remark"
        @input="inputRemark"
        >
      </el-input>
    </div>
    <div class="tp-choose-dot-line"></div>
    <div class="tp-choose">
      <div class="tp-choose-item" :class="{'tp-choose-item-active':template=='standard'}" @click="chooseTemplateType('standard')">
        <div class="tp-choose-icon">
          <img v-if="template=='standard'" src="../../../../assets/images/template2.png">
          <img v-else src="../../../../assets/images/template1.png">
        </div>
        <div>
          <div class="tp-choose-text">阿尔法模版制作</div>
          <div class="tp-choose-sub">阿尔法标准中文模版制作</div>
        </div>
      </div>
      <div class="tp-choose-item" :class="{'tp-choose-item-active':template=='special'}" @click="chooseTemplateType('special')">
        <div class="tp-choose-icon">
          <img v-if="template=='special'" src="../../../../assets/images/templatesp2.png">
          <img v-else src="../../../../assets/images/templatesp1.png">
        </div>
        <div>
          <div class="tp-choose-text">用特殊模版制作</div>
          <div class="tp-choose-sub">要求使用客户自己的模版</div>
          <div v-if="autoSelect" style="font-size:12px;color:#e67720;zoom:0.65;">根据客户要求，已经自动为您选择特殊模版</div>
        </div>
      </div>
      <div class="tp-choose-item" :class="{'tp-choose-item-active':template=='en'}" @click="chooseTemplateType('en')">
        <div class="tp-choose-icon">
          <img v-if="template=='en'" src="../../../../assets/images/en2.png">
          <img v-else src="../../../../assets/images/en1.png">
        </div>
        <div>
          <div class="tp-choose-text">用英文制作</div>
          <div class="tp-choose-sub">要求使用英文制作推荐报告</div>
        </div>
      </div>
    </div>
    <div v-show="template=='special' || template=='en'">
      <div style="font-size:12px;color:#e67720;line-height:40px">
        {{ autoSelect? '根据您选择的项目客户公司，该公司需要使用特殊模版，已默认为您选择': '下列中如果没有你需要的模版，请线下告诉数据同事' }}
      </div>
      <div class="rp-attach-table">
        <el-row class="rp-table-head">
          <el-col :span="6">公司</el-col>
          <el-col :span="6">模版名称</el-col>
          <el-col :span="3">上传时间</el-col>
          <el-col :span="6">上传人</el-col>
          <el-col :span="3">预览</el-col>
        </el-row>
        <div class="rp-attachs" style="max-height: calc(100vh - 650px);">
          <template v-if="template=='special'">
            <div v-for="(item, index) in specialTemplates" :key="index" :id="item._id" @click="selectItem(item)">
              <el-row class="rp-attach" :class="{'rp-attach-active':selected === item._id}">
                <el-col :span="6">{{ formatCompany(item.公司) }}</el-col>
                <el-col :span="6">{{ item.模板名称 }}</el-col>
                <el-col :span="3">{{ dateFormat(item.createdAt, 'yyyy-mm-dd') }}</el-col>
                <el-col :span="6">{{ Array.isArray(item.uploader) && item.uploader.length >0 ?item.uploader.join('、'):'无' }}</el-col>
                <el-col :span="3"><span class="rp-a-link" @click.stop="preview(item)">查看预览</span></el-col>
              </el-row>
            </div>
          </template>
          <template v-else-if="template=='en'">
            <div v-for="(item, index) in enTemplates" :key="index" :id="item._id" @click="selectItem(item)">
              <el-row class="rp-attach" :class="{'rp-attach-active':selected === item._id}">
                <el-col :span="6">通用</el-col>
                <el-col :span="6">{{ item.模板名称 }}</el-col>
                <el-col :span="3">{{ dateFormat(item.createdAt, 'yyyy-mm-dd') }}</el-col>
                <el-col :span="6">{{ Array.isArray(item.uploader) && item.uploader.length >0 ?item.uploader.join('、'):'无' }}</el-col>
                <el-col :span="3"><span class="rp-a-link" @click.stop="preview(item)">查看预览</span></el-col>
              </el-row>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  data() {
    return {
      remark: '',
      maker: '',
      template: '',
      autoSelect: false,
      selected: undefined,
      specialTemplates: [],
      enTemplates: [],
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
  },
  methods: {
    async init({companyName}) {
      if (this.specialTemplates.length == 0) {
        await this.loadTemplates()
      }
      this.chooseMaker('other')
      if (companyName) {
        const item = this.specialTemplates.find(st=>st.公司.includes(companyName))
        if (item) {
          this.chooseTemplateType('special')
          this.selectItem(item)
          this.$nextTick(()=>{
            document.getElementById(item._id).scrollIntoView()
          })
          return this.autoSelect = true
        }
      }
      this.chooseTemplateType('standard')
    },
    async loadTemplates() {
      const res = await app.service('file').getAllTemplateFiles()
      if (res.status == 'success') {
        this.specialTemplates = res.data.data.filter(dt=> {
          return dt.模板名称 != '阿尔法推荐模板' && dt.模板名称 != '阿尔法英文推荐模板' && dt.模板名称 != '阿尔法中英文推荐模板'
        }
         )
        this.enTemplates = res.data.data.filter(dt=>dt.模板名称 == '阿尔法英文推荐模板' || dt.模板名称 == '阿尔法中英文推荐模板')
      }
    },
    chooseMaker(maker) {
      this.maker = maker
      this.$emit('chooseMaker', maker)
    },
    chooseTemplateType(tmp) {
      this.template = tmp
      this.$emit('chooseTemplateType', tmp)
      if (tmp === 'en') {
        const item = this.enTemplates[0]
        this.selectItem(item)
      } else {
        this.$emit('selectItem', {})
      }
    },
    async preview(file) {
      console.log(file)
      const ref = window.app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    selectItem(item) {
      this.selected = item._id
      this.autoSelect = false
      this.$emit('selectItem', item)
    },
    inputRemark() {
      this.$emit('inputRemark', this.remark)
    },
    formatCompany(com) {
      if (!com || !Array.isArray(com) || com.length == 0) return '无'
      if (com.length > 2) {
        return com.slice(0, 2).join('、')+'等'
      } else {
        return com.join('、')
      }
    }
  }
}
</script>
<style>
  .tp-choose {
    display: flex;
    justify-content: center;
  }
  .tp-choose-item {
    padding: 25px 25px 25px 15px;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    display: flex;
    margin: 10px 20px;
    cursor: pointer;
    min-width: 250px;
    align-items: center;
  }
  .tp-choose-item.tp-choose-block {
    padding: 15px 10px;
    margin: 10px 0;
  }
  .tp-choose-icon {
    padding: 0 10px;
    height: 30px;
  }
  .tp-choose-icon img {
    height: 100%;
  }
  .tp-choose-item.tp-choose-block .tp-choose-icon {
    height: 20px;
  }
  .tp-choose-item.tp-choose-item-active, .tp-choose-item:hover {
    font-weight: bold;
    border-color: #719bbe;
    box-shadow: 0px 0px 1px 1px #aec7db;
  }
  .tp-choose-text {
    font-size: 14px;
    padding-right: 15px;
    color: #333;
  }
  .tp-choose-sub {
    font-size: 12px;
    color: #999;
  }
  .tp-choose-dot-line {
    text-align: center;
    border-bottom: 1px dashed #e4e4e4;
    margin: 20px 0 15px 0;
  }
  .tp-choose-dot-line::after {
    content: '选择以下方式制作';
    color: #999;
    position: relative;
    top: 10px;
    padding: 0 5px;
    background: #fff;
  }
  .tp-textarea.el-textarea {
    font-size: 12px;
  }
</style>
